import React from "react";
import MobileBar from "./components/MobileBar";
import Sidebar from "./components/Sidebar";
import Profile from "./components/Profile";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import './index.css';

// One page, laid out like the CV: identity on the left (sticky on desktop), details on the right.
function App() {
  return (
    <div id="top" className="relative isolate min-h-screen overflow-x-clip bg-ink text-fg">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-accent focus:px-5 focus:py-3 focus:text-sm focus:font-semibold focus:text-accent-fg"
      >
        Skip to content
      </a>
      <MobileBar />
      <div className="shell lg:grid lg:grid-cols-[22rem_minmax(0,1fr)] xl:grid-cols-[25rem_minmax(0,1fr)]">
        <Sidebar />
        <main id="main" tabIndex={-1} className="outline-none lg:border-l lg:border-fg/10 lg:pl-14 xl:pl-20">
          <Profile />
          <Experience />
          <Projects />
          <Skills />
          <Education />
          <Contact />
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default App;
